export const BASE_COMBO_MACHINE_ADDRESS = "0xcb92A90F00f35618Cd87515aD4948FAC8BE6D231" as const;
export const BASE_FLEX_COMBO_MACHINE_ADDRESS = "0x40bA6F395C2539Aa9F4e34e2220d73C8f27aa1Ae" as const;
export const BASE_EVENT_MARKET_REGISTRY_ADDRESS = "0x2EA55294eaC5D458292E313D7be83E7Fd4Cc315F" as const;
export const BASE_CREDIT_TOKEN_ADDRESS = "0xa1cc3489a97f1Fa5E6f42AB0957b5De4082126e0" as const
export const BASE_CHAIN_ID = 8453 as const;
export const BASE_SAFE_CONFIRMATIONS = 3 as const;
export const BASE_USDC_ADDRESS = "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913" as const;
export const BASE_MAX_GAS_LIMIT = 4_000_000	as const;
export const BASE_BET_MAX_GAS_USAGE = 300_000 as const;
export const BASE_BET_MIN_GAS_USAGE = 160_000 as const;
export const BASE_MAX_PARALLEL_TXS = 16 as const;
